import {
  GET_USERS,
  GET_MESSAGES,
  ADD_MESSAGE,
  DELETE_MESSAGE,
  DELETE_MESSAGES,
  MESSAGE_ERROR,
  CLEAR_MESSAGES,
  CLEAR_USERS,
  DELETE_CONVERSATION,
} from "../actions/types";

const initialState = {
  message: {},
  messages: [],
  users: [],
  loading: true,
  error: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_USERS:
      return {
        ...state,
        users: payload,
        loading: false,
      };
    case GET_MESSAGES:
      return {
        ...state,
        messages: payload,
        loading: false,
      };
    case ADD_MESSAGE:
      return {
        ...state,
        messages: payload,
        loading: false,
      };
    case DELETE_MESSAGE:
    case DELETE_MESSAGES:
    case DELETE_CONVERSATION:
      return {
        ...state,
        messages: payload,
        loading: false,
      };
    case MESSAGE_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case CLEAR_MESSAGES:
      return {
        ...state,
        message: {},
        messages: [],
        users: [],
        error: {},
        loading: true,
      };
    case CLEAR_USERS:
      return {
        ...state,
        users: [],
      };
    default:
      return state;
  }
}
